// any type is necessary here
export const getProperErrorMessage = (error: any, fallback: string): string => {
  const message =
    error?.graphQLErrors?.[0]?.extensions?.response?.message || fallback;
  const errorMessage = Array.isArray(message) ? message[0] : message;

  return errorMessage;
};
